import AppMain from './app-main';

export default AppMain;
